/// <amd-module name="Widgets/CumulativeFlowDiagram/DateUtils" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { RollingTimePeriod, StartDateTimePeriod } from "./CumulativeFlowDiagramContracts";

export async function extractStartDate(pageContext: IVssPageContext, timePeriod: RollingTimePeriod | StartDateTimePeriod): Promise<string> {
    let startDate: string;
    if (timePeriod.identifier === "RollingPeriod") {
        const today = dateStringAsUTCDate(await fetchTodayInAccountTimeZone(pageContext));
        startDate = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() - timePeriod.settings))
            .toISOString()
            .substr(0, 10);
    } else {
        startDate = timePeriod.settings;
    }

    return startDate;
}

// The functions below this comment will be replaced by common implementations once the Burndown/Burnup widgets are ported

/**
 * Returns a date string representing today in the account time zone.
 * The string is in the format yyyy-MM-dd (e.g. 2019-05-03).
 */
export async function fetchTodayInAccountTimeZone(context: IVssPageContext): Promise<string> {
    const dataProviderContributionId = "ms.vss-dashboards-web.collection-time-zone-data-provider";
    const contributionService = context.getService<IVssContributionService>("IVssContributionService");
    const accountTimeZone = await contributionService.getDataAsync<{ utcOffset: number }>(dataProviderContributionId);

    if (accountTimeZone == null) {
        const dataProviderExceptions = contributionService.getDataProviderExceptions();
        const ex = dataProviderExceptions[dataProviderContributionId];
        const message = ["Failed to retrieve today in account time zone.", ex.message].join(" ");
        throw new Error(message);
    }

    return new Date(Date.now() + accountTimeZone.utcOffset).toISOString().substr(0, 10);
}

export function daysBetweenDates(a: string, b: string): number {
    const dateA = dateStringAsUTCDate(a);
    const dateB = dateStringAsUTCDate(b);

    return Math.abs(dateA.getTime() - dateB.getTime()) / 86400000;
}

export function dateStringAsDate(date: string): Date {
    const dateParts = date.split("-");
    return new Date(+dateParts[0], +dateParts[1] - 1, +dateParts[2]);
}

export function dateStringAsUTCDate(date: string): Date {
    const dateParts = date.split("-");
    return new Date(Date.UTC(+dateParts[0], +dateParts[1] - 1, +dateParts[2]));
}
